
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article-hub",
      function () {
        return require("private-next-pages/article-hub/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article-hub"])
      });
    }
  